module.exports = __webpack_public_path__ + "img/dis01.85f194ab.png";